import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import CssSpinner from '../../../../../../../common/cssSpinner';
import { ERROR_CODES } from '../../../../../../../common/utils/apiErrors'
import Deposit from '../../../../../../../common/deposit'
import {
    actions as betActions,
} from '../../../../../../../common/bet';
import {
    actions as freeBetsActions,
} from '../../../../../../../common/freeBets';
import {
    selectors as userInfoSelectors,
} from '../../../../../../../common/userInfo';
import {
    selectors as bookmakersInfoSelectors,
    actions as bookmakersInfoActions,
} from '../../../../../../../common/bookmakersInfo';
import {
    selectors as bookmakersListSelectors,
    actions as bookmakersListActions,
} from '../../../../../../../common/bookmakersList';
import { GENERIC_ERROR } from '../../../../../../../common/globalModal/modalMessages'
import {
    actions as modalActions,
} from '../../../../../../../modals'
import './styles.scss';

const {
    betObstructions,
} = betActions;

const titles = {
    [betObstructions.REMOVE]: {
        quickslip: 'Accept and Cancel',
        betslip: 'Remove Suspended',
    },
    [betObstructions.ACCEPT]: {
        quickslip: 'Accept',
        betslip: 'Accept',
    },
    [betObstructions.ACCEPT_AND_REMOVE]: {
        quickslip: 'Accept & Remove',
        betslip: 'Accept & Remove',
    },
}

export class CTA extends Component {

    constructor() {
        super();

        this.onSubmit = this.onSubmit.bind(this);
        this.renderLogin = this.renderLogin.bind(this);
        this.getCTATitle = this.getCTATitle.bind(this);
    }

    onSubmit() {
        const {
            obstruction,
            setBetObstruction,
            clearSuspendedBets,
            updateAllBetPrices,
            updateAllStartingPricesAvailability,
            clearAllErrors,
            clearAllMultiplesErrors,
            clearMultiples,
        } = this.props;

        switch (obstruction) {
            case betObstructions.REMOVE:

                clearSuspendedBets();
                clearAllErrors()
                setBetObstruction(betObstructions.NONE);
                clearMultiples()

                break;
            case betObstructions.ACCEPT:

                updateAllBetPrices();
                updateAllStartingPricesAvailability();
                clearAllErrors()
                clearAllMultiplesErrors()
                setBetObstruction(betObstructions.NONE);

                break;

            case betObstructions.ACCEPT_AND_REMOVE:

                updateAllStartingPricesAvailability();
                clearSuspendedBets();
                updateAllBetPrices();
                clearAllErrors()
                setBetObstruction(betObstructions.NONE);
                clearMultiples()

                break;
            default:
                this.placeBet();
        }
    }

    getCTATitle() {
        const {
            isQuickslipMode,
            obstruction,
        } = this.props;

        const mode = (isQuickslipMode) ? 'quickslip' : 'betslip';
        return titles[obstruction][mode];
    }

    placeBet = () => {
        const {
            bookmakerApiName,
            selectedBets,
            getUserInfo,
            feed,
            placeBet,
            clearFreeBets,
            userInfo,
            setIsPlaceBetRequesting,
            multiples,
            buildBetRequest,
            buildBets,
            setGlobalModal,
            isExternalLogout,
            selectedFreeBet,
        } = this.props

        const doPlaceBet = () => (
            placeBet(
                bookmakerApiName,
                selectedBets,
                multiples,
                selectedFreeBet,
                feed,
                userInfo.currencySign,
                isExternalLogout,
            )
            .then(() => {
                // Stop the spinner, clear free bets
                setIsPlaceBetRequesting(false)
                clearFreeBets(feed)

                // Get the user's new balance and free bets
                // Plus, log the user out if something fails here (very basic strategy).
                const promises = []
                promises.push(getUserInfo(bookmakerApiName, feed))
                Promise.all(promises)
                    // Do nothing, as the user can still bet
                    // This could also be resolved at the next attempt elsewhere
                    .catch()
            })
            .catch(() => {
                // Placement did not succeed, errors will have been handled inside the action
                // But - we should now stop the spinner
                setIsPlaceBetRequesting(false)
            })
        )

        const unbuiltBets = selectedBets.filter(bet => (
            !bet.associatedBet || Object.keys(bet.associatedBet).length === 0
        ))

        // If we detect bets that have no `associatedBets`,
        // we cannot correctly place, so a build bet is neccessary.
        // This could occur if the user clicks quickly, or a previous build-bets
        // call failed. This is an automated re-try. See README for more info.
        if (unbuiltBets.length > 0) {
            buildBetRequest(true)
            return buildBets(bookmakerApiName, selectedBets, feed)
                .then(doPlaceBet) // Automatically proceed if bets are built
                .catch(() => {
                    // Otherwise, user must manually try again
                    // We also throw the global modal at this stage
                    setIsPlaceBetRequesting(false)
                    setGlobalModal(GENERIC_ERROR)
                })
        }

        return doPlaceBet()
    }

    renderLogin() {
        const {
            feed,
        } = this.props;

        return (
            <Link
                to={`/${feed}/login`}
                className="bs-btn bs-cta"
            >
                <span className="bs-betForm__buttonLine">
                    Place Bet
                </span>
            </Link>
        );
    }

    renderPlaceBet() {
        const {
            obstruction,
        } = this.props;

        if (obstruction === betObstructions.NONE) {
            return (
                <button
                    className="bs-btn bs-cta"
                    type="submit"
                    onClick={this.onSubmit}
                >
                    <span className="bs-betForm__buttonLine">
                        Place Bet
                    </span>
                </button>
            )
        }
        return (
            <button
                className="bs-btn bs-cta bs-cta_action"
                type="submit"
                onClick={this.onSubmit}
            >
                <span className="bs-cta__buttonLine">
                    {this.getCTATitle()}
                </span>
            </button>
        )
    }

    render() {
        const {
            isLoading,
            isUserLoggedIn,
            feed,
            genericError,
            isQuickslipMode,
        } = this.props;

        if (isQuickslipMode && genericError.errorId === ERROR_CODES.INSUFFICIENT_FUNDS) {
            return (
                <Deposit
                    isUserLoggedIn={isUserLoggedIn}
                    feed={feed}
                    className="bs-btn bs-cta"
                />
            )
        }

        if (isLoading) {
            return (
                <div className="bs-btn bs-cta">
                    <CssSpinner />
                </div>
            );
        }

        if (isUserLoggedIn) {
            return this.renderPlaceBet();
        }

        return this.renderLogin();
    }
}

CTA.defaultProps = {
    isLoading: false,
    isUserLoggedIn: false,
    feed: '',
    selectedBets: [],
    multiples: [],
    userInfo: {},
    genericError: {
        message: null,
        errorId: null,
    },
    isExternalLogout: false,
    selectedFreeBet: null,
}

CTA.propTypes = {
    isLoading: PropTypes.bool,
    isUserLoggedIn: PropTypes.bool,
    isQuickslipMode: PropTypes.bool.isRequired,
    placeBet: PropTypes.func.isRequired,
    getUserInfo: PropTypes.func.isRequired,
    setIsPlaceBetRequesting: PropTypes.func.isRequired,
    clearFreeBets: PropTypes.func.isRequired,
    setBetObstruction: PropTypes.func.isRequired,
    clearSuspendedBets: PropTypes.func.isRequired,
    updateAllBetPrices: PropTypes.func.isRequired,
    bookmakerApiName: PropTypes.string.isRequired,
    obstruction: PropTypes.string.isRequired,
    feed: PropTypes.string,
    selectedBets: PropTypes.arrayOf(
        PropTypes.shape({
            outcomersId: PropTypes.string.isRequired,
            raceTime: PropTypes.string.isRequired,
            courseName: PropTypes.string.isRequired,
            horseName: PropTypes.string.isRequired,
            fractionalPrice: PropTypes.string.isRequired,
            decimalPrice: PropTypes.number, // SP-only bets will not have this
            isSpOnly: PropTypes.bool.isRequired,
            eachWayFraction: PropTypes.string,
            eachWayPlaces: PropTypes.string,
            priceType: PropTypes.string,
            isBog: PropTypes.string,
        }),
    ),
    userInfo: PropTypes.shape({
        name: PropTypes.string,
        balance: PropTypes.number,
        showBalance: PropTypes.bool,
        currencySign: PropTypes.string.isRequired,
    }),
    genericError: PropTypes.shape({
        message: PropTypes.string,
        errorId: PropTypes.string,
    }),
    updateAllStartingPricesAvailability: PropTypes.func.isRequired,
    clearAllErrors: PropTypes.func.isRequired,
    buildBetRequest: PropTypes.func.isRequired,
    buildBets: PropTypes.func.isRequired,
    setGlobalModal: PropTypes.func.isRequired,
    clearMultiples: PropTypes.func.isRequired,
    multiples: PropTypes.arrayOf(
        PropTypes.shape({
            optionId: PropTypes.string.isRequired,
            betType: PropTypes.string.isRequired,
            minStake: PropTypes.number, // Not always available
            maxStake: PropTypes.number, // Not always available
            numberLines: PropTypes.number.isRequired,
            betSelections: PropTypes.array,
        }),
    ),
    isExternalLogout: PropTypes.bool,
    selectedFreeBet: PropTypes.shape({
        id: PropTypes.string.isRequired,
        type: PropTypes.string,
        amount: PropTypes.number.isRequired,
        minStake: PropTypes.number,
        maxStake: PropTypes.number,
    }),
    clearAllMultiplesErrors: PropTypes.func.isRequired,
}

const userInfoSelector = userInfoSelectors.createUserInfoSelector(
    bookmakersInfoSelectors.betBookmakerSelector,
);

const userIsLoggedInSelector = bookmakersListSelectors.createIsLoggedInSelector(
    bookmakersInfoSelectors.betBookmakerSelector,
);

const bookmakerApiNameSelector = bookmakersListSelectors.createBookmakerApiNameSelector(
    bookmakersInfoSelectors.betBookmakerSelector,
);

const mapStateToProps = (state, props) => {
    const {
        isBuildingBet,
        selectedBets,
        multiples,
        genericError,
        isBuildingMultiples,
        selectedBookmaker,
     } = state.bookmakersInfo;
    const {
        isPlacingBet,
        obstruction,
    } = state.bet;
    const {
        isQuickslipMode,
    } = state.drawerInfo;
    const bookmaker = state.bookmakersList.find(bookie => bookie.feed === selectedBookmaker)
    const selectedFreeBet = state.freeBets.list.find(
        freeBet => freeBet.id === state.freeBets.selectedFreeBet,
    )

    return {
        isLoading: isPlacingBet || isBuildingBet || isBuildingMultiples,
        obstruction,
        selectedBets,
        multiples,
        isUserLoggedIn: userIsLoggedInSelector(state),
        feed: bookmakersInfoSelectors.betBookmakerSelector(state),
        bookmakerApiName: bookmakerApiNameSelector(state),
        userInfo: userInfoSelector(state, props),
        isQuickslipMode,
        genericError,
        isExternalLogout: !!(bookmaker && bookmaker.isExternalLogout),
        selectedFreeBet,
    }
}

const mapDispatchToProps = {
    clearSelectedBets: bookmakersInfoActions.clearSelectedBets,
    clearSuspendedBets: bookmakersInfoActions.clearSuspendedBets,
    updateAllStartingPricesAvailability: bookmakersInfoActions.updateAllStartingPricesAvailability,
    updateAllBetPrices: bookmakersInfoActions.updateAllBetPrices,
    setBetObstruction: betActions.setBetObstruction,
    placeBet: betActions.placeBet,
    getUserInfo: bookmakersListActions.getUserInfo,
    clearFreeBets: freeBetsActions.clearFreeBets,
    setIsPlaceBetRequesting: betActions.placeBetRequest,
    clearAllErrors: bookmakersInfoActions.clearAllErrors,
    buildBetRequest: bookmakersInfoActions.buildBetRequest,
    buildBets: bookmakersInfoActions.buildBets,
    setGlobalModal: modalActions.setGlobalModal,
    clearMultiples: bookmakersInfoActions.clearMultiples,
    clearAllMultiplesErrors: bookmakersInfoActions.clearAllMultiplesErrors,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CTA)



// WEBPACK FOOTER //
// /src/js/drawer/components/BetPage/components/ActionBar/components/CTA/CTA.jsx